import React, { useRef } from 'react';
import { useStore } from 'effector-react';
import { MAX_CATEGORIES } from '@constants';
import ScrollbarsHorizontal, {
  type HScrollbarHanlders,
} from '@components/ScrollbarsHorizontal';
import IconArrow from '@components/icons/IconArrow';
import IconPlus from '@components/icons/IconPlus';
import { showConfirmModal } from '@components/ConfirmModal';
import { $subCategoryList } from '@stores/dataStores';
import { TipWrapper } from '@components/TipWrapper';
import SubCategoryItem from './SubCategoryItem';
import addSubCategory from '../actions/addSubCategory';

function SubCategoryList() {
  const list = useStore($subCategoryList);
  const hasSubCategory = !!list.length;
  const scrollRef = useRef<HScrollbarHanlders>(null);

  const handleAddClick = async () => {
    if (list.length >= MAX_CATEGORIES) {
      await showConfirmModal({
        title: '添加失败',
        buttonText: '我知道了',
        content: (
          <>
            <div>{`每个一级分组最多支持添加${MAX_CATEGORIES}个二级分组`}</div>
            <div>添加过多分组将影响作品打开速度，甚至打开失效</div>
          </>
        ),
      });
    } else {
      addSubCategory();
    }
  };

  return (
    <div className="flex h-20 items-center">
      {hasSubCategory && (
        <IconArrow
          className="mr-10 rotate-90 transform rounded-xs bg-black-#34"
          onClick={() => scrollRef.current?.scrollLeft()}
        />
      )}
      <div className="flex h-full flex-grow items-center">
        {hasSubCategory ? (
          <ScrollbarsHorizontal ref={scrollRef} autoHide={false}>
            <div className="-ml-20 flex items-center">
              {list.map((id, i) => (
                <SubCategoryItem id={id} key={id} index={i} />
              ))}
            </div>
          </ScrollbarsHorizontal>
        ) : (
          <div className="flex-grow" />
        )}
        <TipWrapper text="创建二级分组" className="ml-20" size="sm">
          <IconPlus onClick={handleAddClick} />
        </TipWrapper>
      </div>
      {hasSubCategory && (
        <IconArrow
          className="ml-10 -rotate-90 transform rounded-xs bg-black-#34"
          onClick={() => scrollRef.current?.scrollRight()}
        />
      )}
    </div>
  );
}

export default SubCategoryList;
